export default __webpack_public_path__ + "static/media/wewant.c17c8391.svg";